export default {
  // url: "https://www.sj-hospital.org/sjyy",
  // url: "http://10.0.14.91:9061/sjyy",
  // url: "http://10.0.18.250/sjyy",
  // 同一个tomcat下
  url: "/sjyy", // 线上打包
};
